import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { headerSettingsShape } from './headerWidgetHelper';
import LogoWrapper from './Logo/LogoWrapper';
import SiteLinks from './SiteLinks';
import getLinksFromProps from './SiteLinks/getLinksFromProps';
import LanguageSelector from './LanguageSelector';

import './DesktopHeader.module.scss';

class DesktopHeader extends React.PureComponent {
  render() {
    const {
      showSiteLinks,
      imageAlign,
      imageLink,
      imageUrl,
      imageScale,
      designSettings,
      designSettings: { headerLinksColor, headerLinksHoverColor, headerBackgroundColor: backgroundColor },
      isWideScreen,
      language,
      onChangeLanguage,
      ...restProps
    } = this.props;

    return (
      <header styleName={classNames('header', { 'wide-screen': isWideScreen })} style={{ backgroundColor }}>
        <div styleName="content">
          <LogoWrapper
            styleName="logo"
            align={imageAlign}
            {...{
              imageLink,
              imageUrl,
              imageScale,
            }}
          >
            {showSiteLinks && (
              <SiteLinks
                links={getLinksFromProps(restProps)}
                styleName="item"
                color={headerLinksColor}
                hoverColor={headerLinksHoverColor}
              />
            )}
          </LogoWrapper>
          <LanguageSelector language={language} onChange={onChangeLanguage} designSettings={designSettings} />
        </div>
      </header>
    );
  }
}

DesktopHeader.propTypes = {
  designSettings: PropTypes.shape({
    headerBackgroundColor: PropTypes.string,
  }),
  ...headerSettingsShape,
};

export default DesktopHeader;
